// extracted by mini-css-extract-plugin
module.exports = {"trescat":"globals_trescat__nmzeH","gapBefore":"globals_gapBefore__e77de","gapAfter":"globals_gapAfter__XamNT","noGapAfter":"globals_noGapAfter__qN2b_"};